import localforage from "localforage";
import { createI18n } from "vue-i18n";
import { en } from "./assets/locales/en.ts";
import { es } from "./assets/locales/es.ts";
import { nl } from "./assets/locales/nl.ts";
import { fr } from "./assets/locales/fr.ts";
import { pt } from "./assets/locales/pt.ts";
import { it } from "./assets/locales/it.ts";
import { de } from "./assets/locales/de.ts";
import { pl } from "./assets/locales/pl.ts";
import { ro } from "./assets/locales/ro.ts";
import { gr } from "./assets/locales/gr.ts";
//TODO: add new language here
import { STORED_LANG_KEY } from "./constants.ts";

const initializeI18n = async () => {
  const translations = {
    en,
    es,
    nl,
    fr,
    pt,
    it,
    de,
    pl,
    ro,
    gr,
    //TODO: add new language here
  };

  const userLang = navigator.language.split("-")[0];
  const savedLang = await localforage.getItem(STORED_LANG_KEY);

  const i18n = createI18n({
    locale: (savedLang || userLang || "en") as string,
    messages: translations,
  });
  return i18n;
};

export default initializeI18n();
